'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const GridBase = require('./GridBase');
const GridHeader = require('./GridHeader');
const GridItem = require('./GridItem');

class GridSuggestion extends GridBase {
    constructor(props) {
        super(props);

        this.state = {
            quickViewItemId: null
        };

        this._setQuickViewId = this._setQuickViewId.bind(this);
    }

    _getHeader() {
        return (
            <div className="pdp-suggestion-grid-header">
                <GridHeader title={this.props.copy.suggestion.carouselHeader} />
            </div>
        );
    }

    _getItems() {
        return this.props.data.map((data, index) => {
            // index needs to be 1-based, not 0-based
            data.index = index + 1;
            return (
                <div className="pdp-grid-item colLg3 colMd4 colXs6" key={data.id}>
                    <GridItem
                        setQuickViewId={this._setQuickViewId}
                        quickViewItemId={this.state.quickViewItemId}
                        quickView={this.props.quickView}
                        gridType="pdp you may also like"
                        {...data}
                    />
                </div>
            );
        });
    }
}

GridSuggestion.propTypes = {
    data: PropTypes.array,
    copy: PropTypes.object.isRequired,
    quickView: PropTypes.bool,
    darkGrid: PropTypes.bool
};

GridSuggestion.defaultProps = {
    data: [],
    quickView: true,
    darkGrid: true,
    domId: 'suggestion-grid'
};

module.exports = GridSuggestion;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridSuggestion.jsx